import { useState } from "react";
import axios from "axios";
import { appConstants } from "utils/appConstants";
import { showResMsg } from "utils/generic";
import { showDraftSavedMessage } from "components/InlineFeedback/DraftSaveConfirmation";

export default function ContactVerificationNotice({ contact, onSent }) {
  const [sending, setSending] = useState(false);
  const [sentContactId, setSentContactId] = useState(null);
  const hasSent = Boolean(contact?.verificationEmailSentAt) || sentContactId === contact?._id;
  if (contact?.contactType !== "Supplier" || contact.contactVerifiedStatus === "Verified") return null;
  const sendVerification = async () => {
    if (sending) return;
    setSending(true);
    let refreshContact = false;
    try {
      const { data } = await axios.post(
        `${appConstants.baseURL}contact/sendVerification`,
        { _id: contact._id },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
          },
        }
      );
      if (data.Result_Status) {
        if (data.Result_Output?.verificationEmailSent) setSentContactId(contact._id);
        showDraftSavedMessage(
          data.Result_Output?.verificationEmailSent
            ? "Verification email sent successfully"
            : data.Result_Message || "Verification email sent successfully"
        );
        refreshContact = true;
      } else {
        showResMsg(data.Result_Message || "Unable to send verification email.", 7000, false);
      }
    } catch (error) {
      showResMsg(
        error.response?.data?.Result_Message ||
          "Unable to send verification email.",
        7000,
        false
      );
    } finally {
      setSending(false);
    }
    if (refreshContact) onSent?.();
  };
  return (
    <section className="contact-detail-card contact-verification-notice" aria-label="Contact verification">
      <h3>Awaiting contact verification</h3>
      <p>
        This supplier can be selected for documents after they verify the email
        invitation. RCTIs also require an active agreement.
      </p>
      <button
        type="button"
        className="contact-btn-secondary"
        disabled={sending}
        aria-busy={sending}
        onClick={sendVerification}
      >
        {sending ? "Sending…" : hasSent ? "Resend verification email" : "Send verification email"}
      </button>
    </section>
  );
}
